import { oakwood } from '@ourbranch/brand-product';
import { createColorPalette } from '@ourbranch/ui-core';
import { withBrandProduct } from '../../lib/with-brand-product';
// to allow for overrides
const colorPalette = createColorPalette({
    primaryMain: '#327495', // Soft Midnight (custom)
    backgroundsMain: '#EFF0F1', // Cool Rain
    typographyMain: '#394951', // Storm Grey
    controlsMain: '#B1A79C', // Stone
    errorMain: '#7A0027'
});
const frontendConfig = {
    constants: {
        SUPPORT_RENEWAL_AND_CANCEL_QUESTIONS_PHONE: '800-247-8079',
        // todo: confirm oakwood claims number and get claims email
        CLAIMS_PHONE: '800-247-8079',
        CLAIMS_EMAIL: '#',
        AGENCY_SUPPORT_PHONE: '',
        AGENCY_SUPPORT_HOURS: '',
        MEMBER_COMMS_EMAIL: 'this-is@a.placeholder',
        SMS_SHORTCODE: '',
        // TODO: Get terms of use URL for Oakwood
        TERMS_OF_USE_URL: '#',
        // TODO: Get communications consent URL for Oakwood
        COMMUNICATIONS_CONSENT_URL: '#',
        IOS_APP_STORE_URL: '#',
        ANDROID_GOOGLE_PLAY_STORE_URL: '#',
        // Blank: the credit-card fee note is inaccurate for this mutual (#33401).
        SMALL_BILLING_NOTE: ''
    },
    theme: {
        palette: {
            ...colorPalette,
            backgrounds: {
                ...colorPalette.backgrounds,
                lightContrast: '#EFF0F1',
                modal: '#FFFFFF',
                errorAlternate: '#FDF3F2'
            }
        },
        loaderColor: '#327495', //Soft Midnight (custom)
        showLogoInLoader: false,
        showAccountBackgroundHero: false,
        logoWidthDesktop: 320,
        logoWidthMobile: 230
    },
    config: {}
};
const brand = withBrandProduct(oakwood, frontendConfig);
export const constants = brand.constants;
export const theme = brand.theme;
export default brand.config;
